export default function PageContainer({ title, subtitle, action, children }) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
        <div>
          <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight text-[#8A5230]">
            {title}
          </h1>
          {subtitle && <p className="text-base md:text-lg text-[#A06E4D] mt-1">{subtitle}</p>}
        </div>
        {action}
      </div>
      {children}
    </div>
  );
}
